function ModelsMain() {
    return ( 
        <>
            <section className="models-main">
                <div className="container">
                    <div className="heading">Dive into</div>
                    <div className="description">
                    Success stories od some our models and see why OnlyGlance is the trusted partner for maximizing potential on OnlyFans!
                    </div>
                </div>
            </section>
        </>
     );
}

export default ModelsMain;